<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar :logo="logo" :app-name="appName">
      <template slot="links">
        <sidebar-item
          :link="{
            name: 'Inicio',
            path: '/',
            icon: 'fas fa-home',
          }"
        />
        <sidebar-item
            v-if="is('Superadmin') || can('agreements.view.all')"
            :link="{
                  name: trans.get('agreements.hi.agreements'),
                  path: {name:'agreementsList'},
                  icon: 'fas fa-dot-circle'
              }"/>
        <sidebar-item
            v-if="is('Superadmin') || can('forum:categories.view.all')"
            :link="{
                  name: trans.get('forum.hi.forum'),
                  path: {name:'forumList'},
                  icon: 'fas fa-dot-circle'
              }"/>
        <sidebar-item
            v-if="is('Superadmin') || can('additional_information:categories.view.all')"
            :link="{
                  name: trans.get('additional_information.hi.additional_information'),
                  path: {name:'additionalInformationList'},
                  icon: 'fas fa-dot-circle'
              }"/>
        <sidebar-item
            v-if="is('Superadmin') || can('data_bases.view.all')"
            :link="{
                  name: trans.get('data_bases.hi.data_bases'),
                  path: {name:'dataBasesList'},
                  icon: 'fa fa-dot-circle'
              }"/>
        <b-nav-item href="https://app.quolaw.com/" target="_blank">
          <i class="fa fa-dot-circle"></i>
          <span class="nav-link-text">Gestión despacho</span>
        </b-nav-item>
        <sidebar-item
            v-if="is('Superadmin') || can('utilities.view.all')"
            :link="{
                  name: trans.get('utilities.hi.utilities'),
                  path: {name:'utilitiesList'},
                  icon: 'fa fa-dot-circle'
              }"/>

        <sidebar-item
            v-if="is('Superadmin') || can('direct_contacts.view.all')"
            :link="{
                  name: trans.get('direct_contacts.hi.direct_contacts'),
                  path: {name:'directContactList'},
                  icon: 'fa fa-dot-circle'
              }"/>
        <sidebar-item
            v-if="is('Superadmin') || can('videos.view.all')"
            :link="{
                  name: trans.get('videos.hi.videos'),
                  path: {name:'videosList'},
                  icon: 'fa fa-dot-circle'
              }"/>
        <sidebar-item
            v-if="is('Superadmin') || can('various_documents.view.all')"
            :link="{
                  name: trans.get('various_documents.hi.various_documents'),
                  path: {name:'variousDocumentsList'},
                  icon: 'fa fa-dot-circle'
              }"/>
        <sidebar-item
            v-if="is('Superadmin') || can('internal_communications:categories.view.all')"
            :link="{
                  name: trans.get('internal_communications.hi.internal_communications'),
                  path: {name:'internalCommunicationsList'},
                  icon: 'fas fa-dot-circle'
              }"/>
        <sidebar-item v-if="is('Superadmin') || can('offices.view.all')"
                      :link="{
              name: trans.get('offices.hi.offices'),
              path: {name:'officesList'},
              icon: 'fas fa-dot-circle'
              }"
        />
        <sidebar-item v-if="is('Superadmin') || can('roles.manage.all')"
            :link="{
              name: trans.get('roles.hi.roles'),
              path: {name:'rolesList'},
              icon: 'fas fa-dot-circle'
              }"
            />
        <sidebar-item
            v-if="is('Superadmin') || can('professionals.view.all')"
            :link="{
                 name: trans.get('professionals.hi.professionals'),
                 path: {name:'professionalsList'},
                 icon: 'fas fa-dot-circle'
            }"/>
        <sidebar-item
            v-if="is('Superadmin') || can('professionals.manage.all')"
            :link="{
                  name: trans.get('professionals.hi.users'),
                  path: {name:'usersList'},
                  icon: 'fas fa-dot-circle'
              }"/>
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>
      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
        <router-link
            v-if="$route.name !== 'dashboard' && $root.back != null"
            class="btn btn-info btn-go-back-footer"
            ref="goBack"
            :to="$root.back"
            :title="trans.get('hi.go_back')"><i class="fas fa-reply"></i>
        </router-link>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
    /* eslint-disable no-new */
    import PerfectScrollbar from 'perfect-scrollbar';
    import 'perfect-scrollbar/css/perfect-scrollbar.css';
    function hasElement(className) {
        return document.getElementsByClassName(className).length > 0;
    }
    function initScrollbar(className) {
        if (hasElement(className)) {
            new PerfectScrollbar(`.${className}`);
        } else {
            // try to init it later in case this component is loaded async
            setTimeout(() =>
                {
                    initScrollbar(className);
                },
                100);
        }
    }
    import DashboardNavbar from './DashboardNavbar.vue';
    import ContentFooter from './ContentFooter.vue';
    import DashboardContent from './Content.vue';
    import { FadeTransition } from 'vue2-transitions';
    import Lang from "lang.js";
    export default {
        components: {
            DashboardNavbar,
            ContentFooter,
            DashboardContent,
            FadeTransition
        },
      data() {
        return {
          logo: '/img/logo02.png',
          appName: '...'
        };
      },
        methods: {
            initScrollbar() {
                let isWindows = navigator.platform.startsWith('Win');
                if (isWindows) {
                    initScrollbar('sidenav');
                }
            },
        },
      beforeMount() {
        if(typeof window.axios.defaults.headers.common["Authorization"] === 'undefined'){
          this.$router.push({name:'login'})
        }
        else {
          console.log(window.axios.defaults.headers.common["Authorization"]);
        }
          this.logo = `${process.env.MIX_BASE_PATH}/img/logo02.png`;
          this.appName = process.env.MIX_APP_NAME;
      },
      mounted() {
            this.initScrollbar();
        }
    };
</script>
<style src="vue-notifyjs/themes/default.css"></style>
<style lang="scss">

</style>
